module.exports = __webpack_public_path__ + "static/media/diamond4_ipa.41b0b665.png";